import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { MessageSquareText, Phone } from "lucide-react";
import { CONTACT } from "@/data/site";

export const MobileActionBar = () => {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 500);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ y: 80, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 80, opacity: 0 }}
          transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
          className="lg:hidden fixed bottom-0 inset-x-0 z-40 glass border-t border-gold/25 px-4 pt-3 pb-[max(0.75rem,env(safe-area-inset-bottom))] grid grid-cols-2 gap-3"
          data-testid="mobile-action-bar"
        >
          <a
            href={CONTACT.smsHref}
            className="inline-flex items-center justify-center gap-2 bg-gold text-obsidian text-xs tracking-[0.18em] uppercase py-3.5"
            data-testid="mobile-text-btn"
          >
            <MessageSquareText size={15} strokeWidth={1.75} /> Text Kenneth
          </a>
          <a
            href={CONTACT.phoneHref}
            className="inline-flex items-center justify-center gap-2 border border-gold text-gold text-xs tracking-[0.18em] uppercase py-3.5"
            data-testid="mobile-call-btn"
          >
            <Phone size={15} strokeWidth={1.75} /> Call Now
          </a>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
